import React from 'react';
import { footerColumns } from '../data/navigation';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-252" data-mp="3gfsmscqd8umz">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8" data-id="element-253" data-mp="32oe11y52qfc8">
        <div className="sm:col-span-2 lg:col-span-1 lg:pr-8" data-id="element-254" data-mp="36oo9dhgc9hu9">
          <img src="https://cdn.magicpatterns.com/uploads/vBy52qowPNFNY53vkUADE7/SyNeural-logo-no-tagline-half-size.svg" alt="SyNeural" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-255" data-mp="36n3bbhutfgrn" />
          <p className="text-sm leading-relaxed" data-id="element-256" data-mp="3lf582t1l9tng">Building intelligence in the world.</p>
        </div>

        {footerColumns.map(column => <nav key={column.heading} aria-label={column.heading} data-id="element-257" data-mp="3qblyjtw9gk3p">
            <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-258" data-mp="29y5g5yj5lgty">
              {column.heading}
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-259" data-mp="2evxa0y3czd0s">
              {column.links.map(link => <li key={`${column.heading}-${link.label}`} className={link.nested ? 'pl-3 border-l border-white/15' : ''} data-id="element-260" data-mp="3lbmvrwv0jgi0">
                  <a href={link.href} className="hover:text-white transition-colors duration-150" data-id="element-261" data-mp="3v7ggi3ivygav">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-262" data-mp="81pdrea6qp79">
        <p data-id="element-263" data-mp="hstrybs1e611">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-264" data-mp="huwlv6wb8jb1">
          <a href="/privacy" className="hover:text-white transition-colors duration-150" data-id="element-265" data-mp="ct783jhpdrj9">
            Privacy Policy
          </a>
          <a href="/terms" className="hover:text-white transition-colors duration-150" data-id="element-266" data-mp="qub5bme27tm1">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}